module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "level-form"
    }
  }, [(_vm.theme_type !== 'tryout') ? _c('v-card', [_c('div', {
    staticClass: "px-1"
  }, [_c('v-expansion-panels', {
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.list_question), function(data, i) {
    return _c('v-expansion-panel', {
      key: i,
      staticClass: "mb-3",
      staticStyle: {
        "border": "1.5px solid #f0f0f0",
        "border-radius": "5px"
      }
    }, [_c('v-expansion-panel-header', {
      staticClass: "font-weight-bold"
    }, [_vm._v("\n                        Nomor " + _vm._s(data.sequence) + "\n                    ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', [_c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-500 pb-2 d-flex",
      staticStyle: {
        "align-items": "center",
        "justify-content": "space-between"
      }
    }, [_c('div', [_vm._v("Pertanyaan")]), _vm._v(" "), _c('div', [_c('v-btn', {
      staticClass: "primary--text",
      attrs: {
        "depressed": "",
        "color": "#e2f0f7",
        "x-small": "",
        "height": "40"
      },
      on: {
        "click": function($event) {
          return _vm.editQuestion(data)
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v("\n                                                    mdi-pencil\n                                                ")])], 1)], 1)]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "placeholder": "Ketik Pertanyaan",
        "outlined": "",
        "disabled": "",
        "hide-details": "",
        "value": data.question
      }
    }), _vm._v(" "), (data.answers) ? _c('div', {
      staticClass: "py-3"
    }, _vm._l((data.answers), function(row, i) {
      return _c('v-row', {
        key: i,
        staticClass: "pa-3 d-flex",
        staticStyle: {
          "align-items": "center"
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "1"
        }
      }, [_c('v-btn', {
        staticClass: "font-weight-bold primary--text",
        attrs: {
          "fab": "",
          "small": "",
          "depressed": "",
          "color": "#e8f5fa"
        }
      }, [_vm._v("\n                                                    " + _vm._s(_vm.choice_alphabetical[
        i
      ]) + "\n                                                ")])], 1), _vm._v(" "), _c('v-col', {
        staticClass: "font-weight-500",
        attrs: {
          "cols": "8"
        }
      }, [_vm._v("\n                                                " + _vm._s(row.choice_sentence) + "\n                                            ")]), _vm._v(" "), _c('v-col', {
        staticClass: "font-weight-bold",
        attrs: {
          "cols": "2"
        }
      }, [_vm._v("\n                                                Kode : " + _vm._s(row.value) + "\n                                            ")])], 1)
    }), 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "py-3",
      attrs: {
        "align": "right"
      }
    }, [_c('v-btn', {
      attrs: {
        "text": ""
      },
      on: {
        "click": function($event) {
          return _vm.confirmDeleteItem(data)
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "color": "red",
        "small": ""
      }
    }, [_vm._v("mdi-delete")]), _vm._v("\n                                            Hapus\n                                        ")], 1)], 1)], 1)], 1)], 1)])], 1)
  }), 1), _vm._v(" "), (!_vm.list_question.length) ? _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Belum ada soal")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text mt-5 ml-1",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.addQuestion()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n            Tambah Pertanyaan\n        ")], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-5"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('uncompleted', _vm.$attrs.data)
      }
    }
  }, [_vm._v("\n                Kembali\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "color": "blew",
      "type": "button",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n                Lanjutkan\n            ")])], 1)], 1) : _c('v-card', [_c('v-card-text', {
    staticClass: "pt-0"
  }, [(!_vm.selectedBundle.bundle_code) ? _c('div', [_c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "block": "",
      "depressed": "",
      "color": "lightblue"
    },
    on: {
      "click": function($event) {
        _vm.dialogSelectBundleSubtest = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                    Pilih Bundle Subtes\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedBundle.bundle_code) ? _c('div', [_c('div', {
    staticClass: "font-weight-600 mb-2 font-size-16 blacknew--text"
  }, [_vm._v("\n                    Bundle Subtes\n                ")]), _vm._v(" "), _c('v-simple-table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Kode")]), _vm._v(" "), _c('th', [_vm._v("Nama")]), _vm._v(" "), _c('th', [_vm._v("Deskripsi")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "140"
    }
  }, [_vm._v("Jumlah Soal")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "180"
    }
  }, [_vm._v("Aksi")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.selectedBundle.bundle_code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedBundle.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedBundle.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedBundle.total_questions))]), _vm._v(" "), _c('td', [_c('v-btn', {
    staticClass: "blew--text mr-1",
    attrs: {
      "depressed": "",
      "small": "",
      "color": "lightblue"
    },
    on: {
      "click": function($event) {
        return _vm.detailBundle()
      }
    }
  }, [_vm._v("\n                                    Detail\n                                ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text",
    attrs: {
      "depressed": "",
      "small": "",
      "color": "lightred"
    },
    on: {
      "click": function($event) {
        return _vm.removeBundle()
      }
    }
  }, [_vm._v("\n                                    Hapus\n                                ")])], 1)])])])], 1) : _vm._e()]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-5"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('uncompleted', _vm.$attrs.data)
      }
    }
  }, [_vm._v("\n                Kembali\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "pull-right white--text",
    attrs: {
      "color": "blew",
      "type": "button",
      "depressed": "",
      "disabled": !_vm.selectedBundle.bundle_code
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n                Lanjutkan\n            ")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogQuestion),
      callback: function($$v) {
        _vm.dialogQuestion = $$v
      },
      expression: "dialogQuestion"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "font-weight-bold darkgrey--text"
  }, [_vm._v("\n                " + _vm._s(_vm.question_id ? "Ubah" : "Tambah") + " Pertanyaan\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-list-item', {
    staticClass: "pa-0 mt-5",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-2"
  }, [_vm._v("\n                            Pertanyaan\n                        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Ketik Pertanyaan",
      "outlined": ""
    },
    model: {
      value: (_vm.data.question),
      callback: function($$v) {
        _vm.$set(_vm.data, "question", $$v)
      },
      expression: "data.question"
    }
  })], 1)], 1), _vm._v(" "), (_vm.detail_scale.question_type === 'choice') ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-2"
  }, [_vm._v("\n                            Jawaban\n                        ")]), _vm._v(" "), _vm._l((_vm.answer_choice), function(row, i) {
    return _c('v-row', {
      key: i,
      staticClass: "pa-3 d-flex",
      staticStyle: {
        "align-items": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "1"
      }
    }, [_c('v-btn', {
      staticClass: "font-weight-bold primary--text",
      attrs: {
        "fab": "",
        "small": "",
        "depressed": "",
        "color": "#e8f5fa"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.choice_alphabetical) + "\n                                ")])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "8"
      }
    }, [_c('v-text-field', {
      staticClass: "ml-4",
      attrs: {
        "placeholder": "Ketik Jawaban",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: (row.choice_sentence),
        callback: function($$v) {
          _vm.$set(row, "choice_sentence", $$v)
        },
        expression: "row.choice_sentence"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('v-select', {
      attrs: {
        "items": _vm.value_answer,
        "placeholder": "Kode",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: (row.value),
        callback: function($$v) {
          _vm.$set(row, "value", $$v)
        },
        expression: "row.value"
      }
    })], 1)], 1)
  })], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-3"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogQuestion = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "depressed": "",
      "dark": "",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n                    Simpan\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "480px"
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', {
    staticClass: "py-2"
  }, [_c('v-card-title', {
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                Apakah anda akan menghapus soal ini ?\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                soal\n                "), _c('b', [_vm._v(_vm._s(_vm.selectedRow ? _vm.selectedRow.question : ""))]), _vm._v(" akan\n                dihapus.\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDialog = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "depressed": "",
      "loading": _vm.isLoadingForm
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem()
      }
    }
  }, [_vm._v("\n                    Ok\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "900px"
    },
    model: {
      value: (_vm.dialogSelectBundleSubtest),
      callback: function($$v) {
        _vm.dialogSelectBundleSubtest = $$v
      },
      expression: "dialogSelectBundleSubtest"
    }
  }, [_c('dialog-bundle', {
    on: {
      "select": function($event) {
        return _vm.onSelectedBundle($event)
      },
      "close": function($event) {
        _vm.dialogSelectBundleSubtest = false
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "900px",
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogDetailBundle),
      callback: function($$v) {
        _vm.dialogDetailBundle = $$v
      },
      expression: "dialogDetailBundle"
    }
  }, [(_vm.dialogDetailBundle) ? _c('dialog-detail-bundle', {
    attrs: {
      "bundle-code": _vm.selectedBundle.bundle_code
    },
    on: {
      "close": function($event) {
        _vm.dialogDetailBundle = false
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0314e1d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/QuestionForm.vue
// module id = 1465
// module chunks = 1